import React, { FormEvent, PureComponent } from "react";
import { connect } from "react-redux";
import { DraperyModule, RootState } from "../redux/modules";
import ValidationForm from "../ui_components/validation/validationForm";
import { ValidationPopupInput } from "../ui_components/validation/validationPopupInput";
import {
    Modal,
    ModalActions,
    ModalHeader as ModalHeaderE,
    ModalContent,
} from "../ui_components/modal";
import styled, {theme} from "../theme";
import {CancelButton, SaveButton} from "../containers/supplier/supplier_modal";
import Bind from "lodash-decorators/bind";
import {SearchSelectProps} from "../components/UI/search_select/search_select";
import { toast } from "sonner";

const ModalContainer = styled(Modal)`
    width: 480px;
    max-width: 90vw;
    max-height: 90vh;
    overflow: hidden;
`;
const ModalHeader = styled(ModalHeaderE)`
    color: #306f82 !important;
    border-bottom: none;
    padding-bottom: 0 !important;

    div {
        width: 100%;
        border-bottom: 10px solid #e6f1f4;
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding-bottom: 0.5rem;
    }

    .modal-title {
        font-size: 26px;
    }
`;

const ModalContentRoom = styled(ModalContent)`
    display: flex;
    flex-direction: column;
    flex: 1 1 auto;
    min-height: 0;
    overflow-y: auto;

    .react-tabs__tab-list {
        border-bottom: 6px solid #338daa;
        margin-bottom: 0;
    }

    .react-tabs__tab {
        margin-right: 10px;
        border-radius: 5px 5px 0 0;
        border: 1px solid #aaa;
        border-bottom: none;
        bottom: 0;
        background-color: white;
        color: ${theme.colors.grayRGBA};

        &:last-child {
            margin-right: 0;
        }
    }

    .react-tabs__tab-panel {
        flex: 1;
    }

    .react-tabs__tab--selected {
        background-color: #338daa;
        color: #fff;
        border-color: transparent;

        &:focus {
            outline: none;
        }
    }

    .react-tabs__tab-panel--selected {
        margin-top: 0;
        display: flex;
        flex-direction: column;
    }

    .react-tabs__tab:focus {
        box-shadow: none;
    }

    .react-tabs__tab:focus::after {
        position: relative;
    }
`;
const RoomFormInput = styled(ValidationPopupInput)`
    padding: 0.35em 0.5em;
    width: 100%;
`;

const SearchSelectWrapper = styled.div`
    width: 100%;
    margin-bottom: 20px;
`;

const ModalForm = styled(ValidationForm)`
    height: 100%;
    min-height: 0;
`;

export const RoomLabel = styled.label`
    color: ${theme.colors.grayRGBA};
`;

export const ClientLabel = styled.label`
    color: ${theme.colors.grayRGBA};
`;
const TwoItemsWrapper = styled.div`
  display: flex;
  flex-direction: column;
`
export interface AddRoomProps {
    isModalOpen: boolean;
    uiHeader: string;
    closeModal(): void;
    addRoom(value: string, reffererModal?: string): Promise<string | undefined>;
    handleSearchClient: SearchSelectProps["onSearch"];
    draperyOrder: DraperyModule.DraperyOrder & { clientName: string };
    handleSearchSelectChange(
        id: number,
        name: string,
        pathId: string,
        pathName: string        
    ): void;
}

interface State {
    roomName: string;
    tabIndex: number;
}

export class RoomModal extends PureComponent<AddRoomProps, State>{

    public constructor(props: AddRoomProps) {
        super(props);
        this.state = {
            roomName: this.props.draperyOrder.customRoom!,
            tabIndex: 0,
        }
    }

    @Bind()
    private onInputChange(e: any){
        this.setState({ roomName: e.target.value })
    }

    @Bind()
    private closeRoomModal() {
        this.props.closeModal();
    }
  
    private submitForm = async (e: FormEvent<HTMLFormElement>) => {
        const { addRoom } = this.props;
        const { roomName } = this.state;
        const error = await addRoom(roomName, "addRoomModal");

        if (error) {
            toast.error(error);
            return;
        }

        this.closeRoomModal();
    };

    componentWillReceiveProps(nextProps: Readonly<AddRoomProps>, nextContext: any): void {
        this.setState({ roomName: nextProps.draperyOrder.customRoom! })
    }

    private handleInvalidElem = (e: HTMLElement): void => {
        if (e.dataset.index && +e.dataset.index !== this.state.tabIndex) {
            this.setState({ tabIndex: +e.dataset.index }, () => {
                e.scrollIntoView({ behavior: "smooth", block: "center" });
            });
        } else {
            e.scrollIntoView({ behavior: "smooth", block: "center" });
        }
    };

    render(): JSX.Element {
        return(
            <ModalContainer
                uiActive={this.props.isModalOpen}
                uiOnRequestClose={this.closeRoomModal}
                uiDefaultSizes={false}
            >
                <ModalForm
                    id="roomForm"
                    uiOnSubmit={this.submitForm}
                    uiPadding={false}
                    uiReportValidityMode="firstInvalid"
                    uiOnInvalidElem={this.handleInvalidElem}
                >
                    <ModalHeader>
                        <div>
                            <span className="modal-title">
                               {this.props.uiHeader}
                            </span>
                            </div>
                    </ModalHeader>

                    <ModalContentRoom>

                        <TwoItemsWrapper>
                            <SearchSelectWrapper>
                                <ClientLabel>Client Name: {this.props.draperyOrder.clientName}</ClientLabel>
                            </SearchSelectWrapper>
                                <RoomLabel>Room Name</RoomLabel>
                                    <RoomFormInput
                                        id="roomName"
                                        name="roomName"
                                        className="label"
                                        onChange={this.onInputChange}
                                        type="text"
                                        uiReportOnBlur={false}
                                        list="autocompleteOff"
                                        required={true}
                                        value={this.state.roomName}
                                    />
                        </TwoItemsWrapper>
                    </ModalContentRoom>
                    <ModalActions>
                        <CancelButton
                            className="cancel_btn"
                            type="button"
                            uiColor="secondary"
                            onClick={this.closeRoomModal}
                        >
                            Cancel
                        </CancelButton>

                        <SaveButton
                            className="primary_btn"
                            type="submit"
                            form="roomForm"
                            uiColor="primary"
                        >
                            Save
                        </SaveButton>
                    </ModalActions>
                </ModalForm>
            </ModalContainer>
        )

    }
}

function mapStateToProps(
    state: RootState,
    ownProps: AddRoomProps
): AddRoomProps {
    return {
        ...ownProps,
    };
}

export default connect(mapStateToProps)(RoomModal);
